import { call, put, select } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import { ApplicationState } from '@store/types'
import services from '@services'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { StepRefin } from '@utils/enums'

import { ContratacaoRequestPayload } from '../types'
import { contratacaoSuccess, contratacaoError, contratacaoRequest } from '../actions'

export default function* postContratacaoSaga(action: AnyAction) {
  const payload = action.payload as ContratacaoRequestPayload
  const { accessToken } = yield* select((state: ApplicationState) => state.session)
  try {
    yield call(
      services.postContratacaoService,
      {
        numberOfInstallments: payload.numberOfInstallments,
        hasInsurance: payload.hasInsurance,
      },
      accessToken,
    )
    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'postContratacaoService' }))
    yield put(contratacaoSuccess())
    yield payload.callback()
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'postContratacaoService' }))
    yield put(contratacaoError())
    if (typeof payload.errorCallback === 'function') {
      yield payload.errorCallback()
    }
    yield put(
      showError({
        title: 'Erro ao contratar proposta',
        message: 'Ocorreu um erro ao contratar proposta',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_CONTRATACAO_PROPOSTA,
        actionCallback: () => contratacaoRequest(payload),
      }),
    )
  }
}
